module.exports = __webpack_public_path__ + "static/img/fish48.cd3a587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish48.png
// module id = cse9
// module chunks = 0